import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AnalysisTypeDto } from '../../../models/dto/analysis-type.dto';

@Component({
  selector: 'app-sectra-url-modal',
  templateUrl: './sectra-url-modal.component.html',
  styleUrls: ['./sectra-url-modal.component.css']
})
export class SectraUrlModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  sectraUrl: string;
  modalReference: NgbModalRef;
  analysisTypes: AnalysisTypeDto[];
  analysisTypeId: string;
  enabledAnalysisTypes: number;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true
  };

  constructor(private modalService: NgbModal) { }

  async open(sectraUrl: string, analysisTypes: AnalysisTypeDto[], wide?: boolean): Promise<boolean> {
    this.enabledAnalysisTypes = analysisTypes.filter(x => x.enabled).length;
    this.analysisTypeId = null;
    this.analysisTypes = analysisTypes;
    this.sectraUrl = sectraUrl;
    this.ngbModalOptions.size = wide ? 'md' : 'sm';
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    return await this.modalReference.result.then();
  }

  onAnalysisTypeChange(event: any) {
    this.analysisTypeId = event.value;
  }

}
